<mat-calendar
  [selected]="selectedRange"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [dateClass]="getDateClass"
  [startAt]="startAt"
  (_userSelection)="handleDateClick($event)"
></mat-calendar>
